import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CodePanneOccurrence } from 'src/app/model/breakdowns/breakdown';
import { CallStat, CodePanne, ContractType } from 'src/app/model/call/call.model';
import { CallService } from 'src/app/services/http/call/call.service';
import { UtilsService } from 'src/app/services/tools/utils.service';

@Component({
  selector: 'app-nb-panne-codes',
  templateUrl: './nb-panne-codes.component.html',
  styleUrls: ['./nb-panne-codes.component.scss']
})
export class NbPanneCodesComponent implements OnInit {

  selectedPannes!: CodePanne[];
  public startCP: any;
  public endCP: any;


  get displayedColumnNbCodePanne(): string[] {
    const result: string[] = ['code','nom', 'nb'];
    return result;
  }

  constructor(private service: CallService,
    private builder: FormBuilder,
    private utils: UtilsService,
    private router: Router) { }

  /**
   * Boolean indicating if spinner has to be shown while something is being loaded
   */
  public isLoading: boolean = false;


  /**
   * Existing breakdown codes
   */
  codesPannes!: CodePanne[];


  /**
   * Date Pickers Form for Code Panne
   */
  panneCodesForm!: FormGroup;



  /**
   * List of nb of code panne
   */
  nbCodePanne !: CodePanneOccurrence[];

  ngOnInit(): void {

    /** Load the breakdowns codes available */
    this.service.getCodesPannes().subscribe((codesPannes) => {
      codesPannes.push({code:"PF0",nom:"PANNEAU CHAMBRE"}) ;
      this.codesPannes = codesPannes;
      this.selectedPannes = this.codesPannes;
    });


    this.panneCodesForm = this.builder.group({
      startDateCodePanne: ['', Validators.required],
      endDateCodePanne: ['', Validators.required]
    }
    );
  }




  public getNiceDate(date: string) {
    return this.utils.getNiceDate(date);
  }


  onKey(event: any) {

    this.selectedPannes = this.searchPannes(event.target.value);
  }

  searchPannes(value: string) {
    let filter = value.toLowerCase();
    return this.codesPannes.filter(option => option.nom.toLowerCase().includes(filter) || option.code.toLowerCase().includes(filter));
  }

  clickCall(row: CallStat) {
    this.router.navigate(['call', row.ID_SAV_SUIVI]);
  }


  public getData(): any[] {

    var newAr = JSON.parse(JSON.stringify(this.nbCodePanne));
    console.log(newAr)
    newAr.unshift({ code: 'Du : ' + this.getNiceDate(this.startCP), nom: 'Au : ' + this.getNiceDate(this.endCP),  nb: 0 });

    return newAr;
  }

  /**
   * Nb of Code Panne for selected dates
   */
   onSubmitCodePanne() {
    if (!this.panneCodesForm.valid) {
      return;
    }
    this.isLoading = true;
    let doDat: Promise<CallStat[]>[] = [];
    this.startCP = this.panneCodesForm.controls.startDateCodePanne.value;
    this.endCP = this.panneCodesForm.controls.endDateCodePanne.value;

    this.codesPannes.forEach(code => {
      doDat.push(this.service.getCallsPromise(
        code.code, this.startCP, this.endCP
      ));
    });
    let array: any[] = [];
    Promise.all(doDat).then(values => {
      for (let i = 0; i < values.length; i++) {
        array.push({ code: this.codesPannes[i].code, nom:this.codesPannes[i].nom, nb: values[i].length });
      }
      this.nbCodePanne = array;
      this.isLoading = false;
    });

  }

}
